import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const Rent = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Aluguel'}
            horizontal={false}
            subtitles={chartData?.rent?.map((item) => item.description)}
            values={chartData?.rent?.map((item) => item.total  ||  0)}
        />
    );
};
